import * as Sentry from '@sentry/vue'
import PresentationApi from '@/api/presentation'

const SET_WRAP_UP_DATA = 'SET_WRAP_UP_DATA'
const SET_LOADING_WRAP_UP = 'SET_LOADING_WRAP_UP'
const SET_UPLOADING_SCREENSHOT = 'SET_UPLOADING_SCREENSHOT'

const _state = {
  wrapUpData: null,
  isLoadingWrapUpData: false,
  isUploadingScreenshot: false,
}

const getters = {
  wrapUpData(state) {
    return state.wrapUpData
  },
  isLoadingWrapUpData(state) {
    return state.isLoadingWrapUpData
  },
}

const actions = {
  getWrapUpDataAction: async ({ commit }, { onSuccess, onFailure }) => {
    commit(SET_LOADING_WRAP_UP, true)
    try {
      const data = await PresentationApi.getYearWrapUp()
      commit(SET_WRAP_UP_DATA, data)
      if (onSuccess) {
        onSuccess(data)
      }
    } catch (err) {
      Sentry.captureException(err)
      if (onFailure) {
        onFailure(err)
      }
    } finally {
      commit(SET_LOADING_WRAP_UP, false)
    }
  },

  uploadScreenshotAction: async ({ commit }, payload) => {
    commit(SET_UPLOADING_SCREENSHOT, true)
    const response = await PresentationApi.uploadScreenshot(payload)
    commit(SET_UPLOADING_SCREENSHOT, false)
    return response.imageUrl
  },
}

const mutations = {
  [SET_WRAP_UP_DATA](state, wrapUpData) {
    state.wrapUpData = wrapUpData
  },
  [SET_LOADING_WRAP_UP](state, isLoading) {
    state.isLoadingWrapUpData = isLoading
  },
  [SET_UPLOADING_SCREENSHOT](state, isLoading) {
    state.isUploadingScreenshot = isLoading
  },
}

export default {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}
